import { filter, take } from 'rxjs/operators';

import { NavigationEnd, Router } from '@angular/router';
import { NavigationClient, NavigationOptions } from '@azure/msal-browser';
import { StorageService } from '@core/services/storage.service';

import { unauthorizedContentRedirectKey } from './redirect-util';
import { NgZone } from '@angular/core';

export class CustomNavigationClient extends NavigationClient {
    private router: Router;
    private storageService: StorageService;

    constructor(
        router: Router,
        storageService: StorageService,
        private ngZone: NgZone
    ) {
        super();
        this.router = router;
        this.storageService = storageService;
    }

    async navigateInternal(url: string, _options: NavigationOptions): Promise<boolean> {
        let path: string;
        const contentUserAttemptedToAccess = this.storageService.get(unauthorizedContentRedirectKey);
        if (contentUserAttemptedToAccess) {
            path = contentUserAttemptedToAccess;
        } else {
            path = url.replace(window.location.origin, '');
        }

        this.router.events
            .pipe(
                filter((event): event is NavigationEnd => event instanceof NavigationEnd),
                take(1)
            )
            .subscribe(event => {
                if (event.url === `/${path}`) {
                    this.storageService.remove(unauthorizedContentRedirectKey);
                }
            });

        // for some reason if this is not wrapped in ngZone.run, the navigation will trigger a warning saying that it was not triggered in a zone
        return this.ngZone.run(() => this.router.navigateByUrl(path, { replaceUrl: true }).then(() => false));
    }
}
